import { render, staticRenderFns } from "./StorageQuestionsTab.vue?vue&type=template&id=920b37a8&scoped=true&"
import script from "./StorageQuestionsTab.vue?vue&type=script&lang=js&"
export * from "./StorageQuestionsTab.vue?vue&type=script&lang=js&"
import style0 from "./StorageQuestionsTab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StorageQuestionsTab.vue?vue&type=style&index=1&id=920b37a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920b37a8",
  null
  
)

export default component.exports